
/**
* src/web/components/user-monthly-activities-table.jsx
* ユーザの月間の日報提出状況テーブル（カレンダー）
*/
import React from 'react'
import connect from '../../connects/user-monthly-activities-table'
import classnames from 'classnames'
import _ from 'lodash'
import moment from 'moment'
import FontIcon from 'react-toolbox/lib/font_icon'
import MonthlyActivityTheme from './themes/user-monthly-activities-table.css'
import Checkbox from 'react-toolbox/lib/checkbox'
import {
  Button,
} from 'react-toolbox/lib/button'
import Tooltip from 'react-toolbox/lib/tooltip'
const TooltipCheckbox = Tooltip(Checkbox)
/**
 * 日報提出状況テーブル
 * 　ウィンドウの幅に応じて、２列に並べて表示するか、１列に表示するかを切り替えるため、
 * 　半月分の日報提出状況テーブルを２つ作成し、その固まりを横並び、縦並びで表示する
 */
function ReportStatusTable(props) {
  const {
    t,
    ui,
    updateUI,
    report_two_rows,
    activityReport,
    edit,
    check,
    onChange,
    user_id,
    group_id,
    current_user_id,
    saveSchedules,
    report_status
  } = props
  
  return (
    <div className={MonthlyActivityTheme.activeTable}>
      <div className={MonthlyActivityTheme.table}>
        {_.map(report_two_rows, (report, i)=> (
          <DateReportStatus key={i} index={i} 
            date_status={report.first_half} 
            onChange={onChange} 
            check={check} 
            user_id={user_id}
            edit={edit} 
            ui={ui} 
            group_id={group_id}
            saveSchedules={saveSchedules}
            report_status={report_status}
            updateUI={updateUI}/>
        ))}
      </div>
      <div className={MonthlyActivityTheme.table}>
        {_.map(report_two_rows.slice(0, report_two_rows.length - 1), (report, i)=> (
          <DateReportStatus key={i} index={i} 
            date_status={report.latter_half} 
            onChange={onChange} 
            check={check} 
            edit={edit} 
            ui={ui} 
            user_id={user_id}
            group_id={group_id}
            saveSchedules={saveSchedules}
            report_status={report_status}
            updateUI={updateUI}/>
        ))}
        <TotalMonthlyActivities activityReport={activityReport} t={t} />
      </div>
    </div>
  )
}

/**
 * 1日の日報・KPI・ノートの投稿件数表示セル
 */

function DateReportStatus(props) {
  const {
    ui,
    updateUI,
    index,
    date_status,
    edit,
    check,
    onChange,
    report_status
  } = props

  const onChangeDate = (status) => {
    const updatedStatus =_.map(props.report_status, item => {
      if(item.reported_at === status.reported_at) {
        return {
          ...status,
          submission: !status.submission,
        }
      }
      return item
    })
    props.saveSchedules(props.group_id, updatedStatus, props.user_id)
  }

  var day_theme = MonthlyActivityTheme.default
  var border_theme = undefined

  if (index == 0 || index == 15) {
    border_theme = MonthlyActivityTheme.borderAll
  }
  else if (index < 14) {
    border_theme = MonthlyActivityTheme.borderNoTop
  }
  else {
    border_theme = MonthlyActivityTheme.border
  }

  if (!date_status) {
    day_theme = MonthlyActivityTheme.empty
  }
  else {  
    switch (date_status.theme) {
      case 'holiday':
        day_theme = MonthlyActivityTheme.holiday
        break
      case 'saturday':
        day_theme = MonthlyActivityTheme.saturday
        break
      case 'default':
        day_theme = MonthlyActivityTheme.default
        break
    }
  }

  if (date_status) {
    return (
      <div className={classnames(MonthlyActivityTheme.rows, border_theme, day_theme)}>
        <div className={MonthlyActivityTheme.date}>{date_status && date_status.date}</div>
        <div className={classnames(MonthlyActivityTheme.borderLeft, MonthlyActivityTheme.date)}>{date_status && date_status.day}</div>
        <div className={classnames(MonthlyActivityTheme.borderLeft, MonthlyActivityTheme.activitiesCell)}>
          {date_status && !edit && date_status.activity &&
            <DateActivitiesCount activity={date_status.activity} submission={date_status.submission} reported_at={date_status.reported_at}/>
            || <TooltipCheckbox checked={date_status.submission}  tooltip={"提出予定を登録する"}
                  theme={MonthlyActivityTheme} className="userMonthly"
                  onChange={() => onChangeDate(date_status)}
                  />
          }
        </div>
      </div>
    )
  }
  else {
    return (
      <div className={classnames(MonthlyActivityTheme.noStatus, day_theme)}>{''}</div>
    )
  }
}

/**
 * 日報・KPI・ノートの投稿件数取得関数
 */
function DateActivitiesCount(props) {
  const {
    activity,
    submission,
    reported_at
  } = props

  const {
    diary,
    memo,
    kpi,
    like,
    comment,
  } = activity
  
  const diary_ids = diary && diary.split(',').map((id)=> parseInt(id)) || []
  const kpi_ids = kpi && kpi.split(',').map((id)=> parseInt(id)) || []
  const memo_ids = memo && memo.split(',').map((id)=> parseInt(id)) || []

  const count_diary = diary_ids.length || 0
  const count_kpi = kpi_ids.length || 0
  const count_memo = memo_ids.length || 0

  if ( count_diary == 0 && count_kpi == 0 && submission) {
    return (
      <div className={MonthlyActivityTheme.empty}>
        {submission && <ActivitiesCount icon={"event_available"} insubmission/>}
        {count_memo != 0 && <ActivitiesCount icon={'assignment'} count={count_memo} />}
      </div>
    )
  }else if (count_diary == 0 && count_kpi == 0 && count_memo == 0){
    return (
      <div className={MonthlyActivityTheme.empty} />
    )
  }else{
    return (
      <div>
        <ActivitiesCount icon={'event_note'} count={count_diary} />
        <ActivitiesCount icon={'insert_chart'} count={count_kpi} />
        <ActivitiesCount icon={'assignment'} count={count_memo} />
      </div>
    )
  }
}

function ActivitiesCount(props) {
  const {
    icon,
    count,
    insubmission,
  } = props

  if (count == 0)
    return (
      <div className={MonthlyActivityTheme.status} />
    )
  else
      return (
        <div className={insubmission ? MonthlyActivityTheme.scheduleStatus : MonthlyActivityTheme.status}>
          <FontIcon className={insubmission ? MonthlyActivityTheme.scheduleIcon : MonthlyActivityTheme.fontIcon} value={icon} />
          {count > 1 &&
            <span className={MonthlyActivityTheme.text}>{count}</span>
          }
          {count == 1 &&
            <span className={MonthlyActivityTheme.text} />
          }
        </div>
      )
}


/**
 * 合計表示セル
 */
function TotalMonthlyActivities(props) {
  const {
    t,
    activityReport,
  } = props

  var total_diary = 0
  var total_kpi = 0
  var total_memo = 0

  _.each(activityReport.activity, (activity, i)=> {
    const diary_ids = activity.diary && activity.diary.split(',').map((id)=> parseInt(id)) || []
    const kpi_ids = activity.kpi && activity.kpi.split(',').map((id)=> parseInt(id)) || []
    const memo_ids = activity.memo && activity.memo.split(',').map((id)=> parseInt(id)) || []

    total_diary += diary_ids && diary_ids.length || 0
    total_kpi += kpi_ids && kpi_ids.length || 0
    total_memo += memo_ids && memo_ids.length || 0
  })

  return (
    <div className={classnames(MonthlyActivityTheme.borderAll, MonthlyActivityTheme.default)}>
      <div className={classnames(MonthlyActivityTheme.totalTitle, MonthlyActivityTheme.totalText)}>
        <span>{t('label:合計')}</span>
      </div>
      <div className={classnames(MonthlyActivityTheme.borderLeft, MonthlyActivityTheme.activitiesCell)}>
        <div className={MonthlyActivityTheme.status}>
          <FontIcon value='event_note' className={MonthlyActivityTheme.fontIcon} />
          <span className={classnames(MonthlyActivityTheme.totalText, MonthlyActivityTheme.text)}>{total_diary}</span>
        </div>
        <div className={MonthlyActivityTheme.status}>
          <FontIcon value='insert_chart' className={MonthlyActivityTheme.fontIcon} />
          <span className={classnames(MonthlyActivityTheme.totalText, MonthlyActivityTheme.text)}>{total_kpi}</span>
        </div>
        <div className={MonthlyActivityTheme.status}>
          <FontIcon value='assignment' className={MonthlyActivityTheme.fontIcon} />
          <span className={classnames(MonthlyActivityTheme.totalText, MonthlyActivityTheme.text)}>
            {total_memo}
          </span>
        </div>
      </div>
    </div>
  )
}

class UserMonthlyActivitiesTable extends React.Component {  
  onWeekdaySelect = () => {
    this.props.updateUI({ weekdaySelect: !this.props.ui.weekdaySelect })
    const updateDates = _.map(this.props.report_status, item => {
      if(item.theme === "default") {
        return {
          ...item,
          submission: !this.props.ui.weekdaySelect
        }
      }
      return item
    })
    this.props.saveSchedules(this.props.group_id, updateDates, this.props.user_id)
  }
  onEdit = () => this.props.changeEdit()
  onCancel = () => {
    this.props.changeEdit()
    this.props.updateUI({ weekdaySelect: false, save: false })
  }
  render() {
    const {
      t,
      ui,
      updateUI,
      isMonthlyFetchFailed,
      activityReport,
      user_id,
      current_user_id,
      group_id,
      date,
      edit,
      fetchMonthlyActivityReport,
      report_status,
      changeEdit,
      schedules,
      report_two_rows,
      saveSchedules,
      group_admin,
    } = this.props

    return (
      <div>
        {user_id && current_user_id && (user_id == current_user_id || group_admin) && 
          <div style={{margin: '1% 5%', display: 'flex', justifyContent: 'flex-end'}}>
            {edit && 
              <div style={{margin: '15px auto 0px 10px'}}>
                {ui.save && <FontIcon value='check_circle' className={MonthlyActivityTheme.save_msg}/>}
                <span style={{ fontSize: 14 }}>{ui.save ? t('label:提出予定登録') : t('label:提出予定登録説明')}</span>
              </div>}
            {edit && <Checkbox className={MonthlyActivityTheme.checkbox} checked={ui.weekdaySelect} label={t('label:平日をすべて選択')} onChange={this.onWeekdaySelect}/>}
            <Button raised primary={!edit}
              icon={edit ? "" : "edit"}
              label={edit ? "完了" : "編集"}
              onClick={edit ? this.onCancel : this.onEdit}
              style={{ verticalAlign: 'bottom', margin: '4px 6px 6px' }} />
          </div>}
        {!isMonthlyFetchFailed && report_two_rows && report_two_rows.length > 0 &&
          <ReportStatusTable t={t} 
            report_two_rows={report_two_rows} 
            activityReport={activityReport} 
            check={ui.check} 
            edit={edit} 
            ui={ui}
            group_id={group_id}
            user_id={user_id}
            saveSchedules={saveSchedules}
            report_status={report_status}
            updateUI={updateUI}/>
        }
        {isMonthlyFetchFailed && 
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:データの取得に失敗しました')}</div>
        }
      </div>
    )
  }
}

export const RawUserMonthlyActivitiesTable = UserMonthlyActivitiesTable
export default connect(UserMonthlyActivitiesTable)


// WEBPACK FOOTER //
// ./src/web/components/user-monthly-activities-table.jsx